import React from "react";

import withStyles from '@mui/styles/withStyles';

import getColorByTask from "../../../../getColorByTask";

type Props = {
  value?: string;
  color?: string;
  classes?: any;
};

const styles = () => ({
  customBadge: {
    borderRadius: "50%",
    width: "12px",
    height: "12px",
    backgroundColor: (props: { color?: string }) => props.color,
  },
  textValue: {
    font: "normal 700 14px/21px Manrope",
    color: (props: { color?: string }) => props.color,
  },
  div: {
    display: "flex",
    flexDirection: "row" as "row",
    gap: "4px",
    alignItems: "center",
  },
});

const SimpleBadge = (props: Props) => {
  const { classes, value } = props;

  return (
    <div className={classes.div}>
      <div className={classes.customBadge}></div>
      <span className={classes.textValue}>{value}</span>
    </div>
  );
};

const StyledBadge = withStyles(styles)(SimpleBadge);

export const TaskTypeBadge = (props: Props) => {
  const { value } = props;

  const renderBadge = (color: string, value?: string) => {
    if (value) return <StyledBadge color={color} value={value} />;

    return <> </>;
  };

  return renderBadge(getColorByTask(value).color, value);
};
